import { useMemo, useState } from 'react'
import { useProductB2C } from '../../../modules/apis/student/products'
import { useCurrentUser } from '../../../modules/context/UserContext'
import { useLocaleVars } from '../../../modules/i18n/useTranslation'
import { add24Hours, getCurrency } from '../../../modules/utils'
import { COUNTRY_ALPHA2_CODE } from '../../../modules/vars'
import useUserStore from '../../../store/useUserStore'
import LoadingSpinner from '../../common/LoadingSpinner'
import { PRICING_PROPERTY, PRICING_TAB } from '../../new-portal/pricing/PricingBodyWeb.util'
import { PricingB2BSelectSection } from '../../new-portal/pricing/PricingDurationSelectSection'
import PricingSwitchCurrency from '../../new-portal/pricing/PricingSwitchCurrency'
import ProductCard from '../../new-portal/pricing/ProductCard'

const PricingMobileBox = ({ item, index }) => {
  const { currentUser } = useCurrentUser()
  const { duration_list, lesson_num_list, package_option_list } = useLocaleVars()
  const currentGeo = useUserStore((state) => state.session.currentGeo)

  const [duration, setDuration] = useState(duration_list[1])
  const [countryCode, setCountryCode] = useState(currentGeo.country_code || COUNTRY_ALPHA2_CODE.KR)
  const expiredAt = useMemo(() => {
    return currentUser ? add24Hours(currentUser?.braze?.private?.signup_date) : add24Hours(new Date())
  }, [currentUser])

  const { data: productGroups, isFetching } = useProductB2C(getCurrency(COUNTRY_ALPHA2_CODE.KR), false, true)

  const getProductLines = (creditList, creditType, duration) => {
    const product = creditList.find((list) => list.properties[creditType])

    if (product) {
      return product.product_lines.filter((line) => line.duration !== duration)
    }
    return []
  }

  const getProductsGroup = (activeId, productGroups, duration) => {
    const creditList = productGroups?.product_groups || []

    switch (activeId) {
      case PRICING_TAB.EVERY_WEEK:
        return getProductLines(creditList, PRICING_PROPERTY.EVERY_WEEK_PRODUCT, duration.number)
      case PRICING_TAB.FLEXIBLE:
        return getProductLines(creditList, PRICING_PROPERTY.FLEXIBLE_PRODUCT, duration.number)
      case PRICING_TAB.B2B:
        return []
    }
  }

  const productsGroup = getProductsGroup(item?.activeTabId, productGroups, duration)

  if (!item) return
  return (
    <section id={index} className="w-full" style={{ backgroundColor: item?.backgroundColor?.hex }}>
      <div className="flex flex-col mx-auto max-w-[px]">
        <div className="relative flex items-start justify-start flex-col">
          <PricingB2BSelectSection duration={duration} setDuration={setDuration} />
          <div className="px-[16px] mt-[24px]">
            <PricingSwitchCurrency />
          </div>
        </div>

        {isFetching ? (
          <div className="flex w-[100%] items-center justify-center">
            <LoadingSpinner show primary lg padded />
          </div>
        ) : (
          <div className="mx-[16px] flex flex-col gap-y-[16px] my-[24px]">
            {productsGroup.map((product, index) => {
              return (
                <ProductCard
                  activeId={item?.activeTabId}
                  item={product}
                  discount={false}
                  key={`${product.id}`}
                  duration={duration}
                  lessonNum={lesson_num_list[0]}
                  packageOption={package_option_list[0]}
                  isMobile={true}
                  expiredAt={expiredAt}
                  countryCode={countryCode}
                  productsGroup={productsGroup}
                />
              )
            })}
          </div>
        )}
      </div>
    </section>
  )
}

export default PricingMobileBox
